var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Created by maxime on 2016-06-21.
 */
import { EventEmitter } from 'events';
var NETWORK_OFFLINE = {
    errorCode: 'NETWORK_OFFLINE',
    message: 'Internet connection is offline'
};
var NETWORK_ONLINE = {
    errorCode: 'NETWORK_ONLINE',
    message: 'Internet connection is online'
};
var NETWORK_NOT_RESPONDING = {
    errorCode: 'NETWORK_NOT_RESPONDING',
    message: 'Server is not responding'
};
var WEBSOCKET_NOT_CONNECTED = {
    errorCode: 'WEBSOCKET_NOT_CONNECTED',
    message: 'Websocket not in connected state'
};
var WEBSOCKET_NOT_READY = {
    errorCode: 'WEBSOCKET_NOT_READY',
    message: 'Websocket not in ready state'
};
var REQUEST_TIMEOUT = {
    errorCode: 'REQUEST_TIMEOUT',
    message: 'Request has timed out'
};
var WEBSOCKET_ERROR = {
    errorCode: 'WEBSOCKET_ERROR',
    message: 'Websocket error event'
};
var WEBSOCKET_CLOSE = {
    errorCode: 'WEBSOCKET_CLOSE',
    message: 'Websocket close event'
};
var WEBSOCKET_HOSTDOWN = {
    errorCode: 'EHOSTDOWN',
    message: 'Too many failed connection attempts'
};
var WEBSOCKET_TIMEDOUT = {
    errorCode: 'ETIMEDOUT',
    message: 'Connection timeout'
};
var SESSION_LOST = {
    errorCode: 'SESSION_LOST',
    message: 'Session loss after network reconnection'
};
var UNHANDLED_MESSAGE = {
    errorCode: 'UNHANDLED_MESSAGE',
    message: 'Received response can not be matched to a request'
};
var UNAVAILABLE = {
    errorCode: 'UNAVAILABLE',
    message: 'Server busy, try again later'
};
var UNAUTHORIZED = {
    errorCode: 'UNAUTHORIZED',
    message: 'Token has expire, need to re-authenticate'
};
var CHANNEL_NOT_CREATED = {
    errorCode: 'CHANNEL_NOT_CREATED',
    message: 'No URL to connect the channel to.'
};
var ChannelEvents = /** @class */ (function (_super) {
    __extends(ChannelEvents, _super);
    function ChannelEvents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The channel is connected and events can be sent or received.
         */
        _this.CONNECTED = 'CHANNEL_CONNECTED';
        /**
         * The channel is in connecting, but no events can be sent or received yet.
         */
        _this.RECONNECTED = 'CHANNEL_RECONNECTED';
        /**
         * The channel is disconnected. No events can be sent or received.
         */
        _this.DISCONNECTED = 'CHANNEL_DISCONNECTED';
        /**
         * The network is online. The channel can be connected.
         */
        _this.ONLINE = 'CHANNEL_NETWORK_ONLINE';
        /**
         * The network is offline. The channel can't be connected.
         */
        _this.OFFLINE = 'CHANNEL_NETWORK_OFFLINE';
        /**
         * The channel has received an event.
         */
        _this.MESSAGE = 'CHANNEL_MESSAGE';
        /**
         * An error on the channel occurred.
         */
        _this.ERROR = 'CHANNEL_ERROR';
        /**
         * The channel needs to be refreshed
         */
        _this.EXPIRED = 'CHANNEL_EXPIRED';
        /**
         * The channel received a conference notification
         */
        _this.CONFERENCE_NOTIFICATION = 'CHANNEL_CONFERENCE_NOTIFICATION';
        /**
         * The notification channel server may be down.
         */
        _this.SERVER_DOWN = 'SERVER_DOWN';
        _this.TERMINATED = 'SERVER_TERMINATED';
        return _this;
    }
    Object.defineProperty(ChannelEvents.prototype, "NETWORK_OFFLINE", {
        // Access to Error and Reason Objects
        get: function () {
            return NETWORK_OFFLINE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "NETWORK_ONLINE", {
        get: function () {
            return NETWORK_ONLINE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "NETWORK_NOT_RESPONDING", {
        get: function () {
            return NETWORK_NOT_RESPONDING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_NOT_CONNECTED", {
        get: function () {
            return WEBSOCKET_NOT_CONNECTED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_NOT_READY", {
        get: function () {
            return WEBSOCKET_NOT_READY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_ERROR", {
        get: function () {
            return WEBSOCKET_ERROR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_CLOSE", {
        get: function () {
            return WEBSOCKET_CLOSE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "REQUEST_TIMEOUT", {
        get: function () {
            return REQUEST_TIMEOUT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "SESSION_LOST", {
        get: function () {
            return SESSION_LOST;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_HOSTDOWN", {
        get: function () {
            return WEBSOCKET_HOSTDOWN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "WEBSOCKET_TIMEDOUT", {
        get: function () {
            return WEBSOCKET_TIMEDOUT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "UNHANDLED_MESSAGE", {
        get: function () {
            return UNHANDLED_MESSAGE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "UNAVAILABLE", {
        get: function () {
            return UNAVAILABLE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "UNAUTHORIZED", {
        get: function () {
            return UNAUTHORIZED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelEvents.prototype, "CHANNEL_NOT_CREATED", {
        get: function () {
            return CHANNEL_NOT_CREATED;
        },
        enumerable: true,
        configurable: true
    });
    return ChannelEvents;
}(EventEmitter));
export default ChannelEvents;
//# sourceMappingURL=channelEvents.js.map